<template>
  <div class="er-actions">
    <environmentalReportProofAction
      :item="item"
      :config="config"
      @reloadData="$emit('reloadData')"
    />
    <v-tooltip bottom v-if="!isReadOnlyUser">
      <template v-slot:activator="{ on }">
        <v-icon medium class="mr-2" v-on="on" @click.stop="editItem(item)">
          edit
        </v-icon>
      </template>
      <span>{{ $t("general.edit") }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="canDeleteHere">
      <template v-slot:activator="{ on }">
        <v-icon medium class="mr-2" v-on="on" @click.stop="openDeleteDialog">
          delete
        </v-icon>
      </template>
      <span>{{ $t("general.delete") }}</span>
    </v-tooltip>
    <deleteDialog
      @triggerDelete="deleteItem"
      :item="item"
      :deleteDialog="deleteDialog"
    />
  </div>
</template>

<script>
import environmentalReportProofAction from "./environmentalReportProofAction.vue";
import deleteDialog from "../../_utils/dataTableHelpers/actions/deleteDialog.vue";
export default {
  props: ["item", "config"],
  components: {
    deleteDialog,
    environmentalReportProofAction,
  },
  data: () => ({
    deleteDialog: {
      open: false,
      title: "environmentalReports.deleteTitle",
      description: "",
    },
  }),
  methods: {
    editItem(item) {
      this.$router.push({
        name: "environmentalReportForm",
        params: { id: item._id || item.id, mode: "edit" },
      });
    },
    openDeleteDialog() {
      this.deleteDialog.description = this.$t(
        "environmentalReports.deleteConfirm",
        { name: this.item.name },
      );
      this.deleteDialog.open = true;
    },
    deleteItem(item) {
      this.$store
        .dispatch("deleteEnvironmentalReport", { id: item._id || item.id })
        .then(() => {
          this.deleteDialog.open = false;
          this.$emit("reloadData");
        });
    },
  },
};
</script>

<style scoped>
.er-actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
}
</style>
